import Vue from 'vue';
import { mapGetters } from 'vuex';
export default Vue.extend({
    computed: Object.assign(Object.assign({}, mapGetters('system_configuration', [
        'activePatternRendering',
    ])), { selection() {
            return this.$store.state.system_configuration.selections.pattern;
        } }),
});
